  (function() {
    if (window.__orpheeCartBound) return;
    window.__orpheeCartBound = true;

    /* ---------- Cart logic ----------
       v15: single-call approach matching SOHO's own assets/product-form.js.
       POST to /cart/add with `sections=cart-drawer,cart-icon-bubble` in the
       formData. Shopify adds the item AND returns the freshly-rendered section
       HTML in the same response. Then we pass that response straight to
       cart-drawer.renderContents() — no second fetch, no race conditions,
       drawer opens with the correct items.
    */
    function getSohoCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function fallbackRefreshBubble() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          if (!data) return;
          var bubble = document.querySelector('.hdr-cart-count-numb');
          if (bubble) {
            bubble.textContent = data.item_count;
            bubble.classList.toggle('hdr-cart-count-empty', data.item_count === 0);
            bubble.classList.toggle('hdr-cart-count-active', data.item_count > 0);
          }
          return data;
        });
    }

    function setBtnState(btn, state) {
      btn.classList.remove('is-loading','is-success','is-error');
      if (state !== 'default') btn.classList.add('is-' + state);
      btn.disabled = (state === 'loading');

      var textEl = btn.querySelector('.orphee-row__cta-text');
      if (textEl) {
        var labels = {
          default: btn.dataset.defaultLabel || 'ADD TO CART',
          loading: btn.dataset.loadingLabel || '…',
          success: btn.dataset.successLabel || '✓',
          error:   btn.dataset.errorLabel   || 'TRY AGAIN'
        };
        textEl.textContent = labels[state] || labels.default;
      }
      var priceEl = btn.querySelector('.orphee-row__cta-price');
      if (priceEl) priceEl.style.display = (state === 'default') ? '' : 'none';
    }

    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-orphee-cart-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.disabled) return;
      setBtnState(btn, 'loading');

      var cart = getSohoCart();
      var formData = new FormData(form);

      // Append `sections` to the formData so Shopify re-renders the cart drawer
      // and bubble server-side and returns them in the same response.
      // This is exactly what SOHO's assets/product-form.js does for the PDP.
      if (cart && typeof cart.getSectionsToRender === 'function') {
        var sectionIds = cart.getSectionsToRender().map(function(s){ return s.id; });
        // FormData.append with an array stringifies via toString() -> comma-joined.
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      // Single POST. NOTE: not `/cart/add.js` — SOHO posts to /cart/add and
      // relies on the X-Requested-With + Accept headers to get JSON back.
      fetch('/cart/add', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData,
        credentials: 'same-origin'
      })
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.status) {
          // Shopify error (e.g. sold out, quantity rule, etc.)
          throw response;
        }

        // Step A: Call SOHO's own renderContents (handles section swap + opens drawer)
        if (cart && typeof cart.renderContents === 'function' && response.sections) {
          try {
            cart.renderContents(response);
          } catch (e) {
            console.warn('Orphee: SOHO renderContents threw, will fall through to manual replace.', e);
          }
        }

        // Step B: Manually strip `is-empty` classes that SOHO does NOT clean up.
        // When the cart was empty on page load, the snippet adds is-empty to
        // <cart-drawer> and <cart-drawer-items>. CSS uses these classes to hide
        // the items table — that's why our drawer was opening blank even though
        // the cart had items.
        document.querySelectorAll(
          'cart-drawer.is-empty, cart-drawer-items.is-empty, .drawer__inner.is-empty'
        ).forEach(function(el) {
          el.classList.remove('is-empty');
        });

        // Step C: Defensive manual replace — guarantees the cart-drawer DOM
        // matches the freshly rendered section HTML, even if SOHO's
        // renderContents misbehaved (e.g. partial update, exception).
        if (response.sections && response.sections['cart-drawer']) {
          try {
            var doc = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
            var newDrawerEl = doc.querySelector('#CartDrawer');
            var existingDrawerEl = document.querySelector('#CartDrawer');
            if (newDrawerEl && existingDrawerEl) {
              existingDrawerEl.innerHTML = newDrawerEl.innerHTML;
            }
            // Strip is-empty again after re-injection (the markup itself shouldn't have it,
            // but parents might keep the class)
            document.querySelectorAll(
              'cart-drawer.is-empty, cart-drawer-items.is-empty'
            ).forEach(function(el) { el.classList.remove('is-empty'); });
          } catch (e) {
            console.warn('Orphee: manual cart-drawer replace failed.', e);
          }
        }

        // Step D: Force-update cart-icon-bubble too (header counter).
        if (response.sections && response.sections['cart-icon-bubble']) {
          try {
            var doc2 = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
            var newBubble = doc2.querySelector('.shopify-section') || doc2.body.firstElementChild;
            var existingBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && existingBubble) {
              existingBubble.innerHTML = newBubble.innerHTML;
            }
          } catch (e) {
            console.warn('Orphee: cart-icon-bubble update failed.', e);
          }
        }

        // Step E: Open the drawer (SOHO's renderContents tries this too, but be safe).
        if (cart && typeof cart.open === 'function') {
          try { cart.open(); } catch (e) {}
        }
      })
      .then(function() {
        setBtnState(btn, 'success');
        setTimeout(function() { setBtnState(btn, 'default'); }, 1800);
      })
      .catch(function(err) {
        console.error('Orphee add-to-cart failed', err);
        setBtnState(btn, 'error');
        setTimeout(function() { setBtnState(btn, 'default'); }, 2400);
      });
    }, false);

    /* ---------- Mobile swipe-indicator binding (left + right panels) ----------
       Generic: takes the scroller selector, slide selector, dot selector, and
       the data-attr name used to map slide index. Used by both the left
       editorial panel and the right product gallery carousel. */
    function bindIndicator(containerSel, slideSel, dotSel, dataAttr, boundFlag) {
      var containers = document.querySelectorAll(containerSel);
      containers.forEach(function(container) {
        if (container[boundFlag]) return;
        container[boundFlag] = true;

        var article = container.closest('.orphee-row');
        var dots = article ? article.querySelectorAll(dotSel) : null;
        var slides = container.querySelectorAll(slideSel);
        if (!dots || !dots.length || slides.length <= 1) return;

        function setActive(idx) {
          dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function(entries) {
            var best = null;
            entries.forEach(function(en){
              if (!best || en.intersectionRatio > best.intersectionRatio) best = en;
            });
            if (best && best.isIntersecting) {
              var idx = parseInt(best.target.getAttribute(dataAttr), 10);
              if (!isNaN(idx)) setActive(idx);
            }
          }, { root: container, threshold: [0.5, 0.75, 1] });
          slides.forEach(function(s){ io.observe(s); });
        } else {
          container.addEventListener('scroll', function() {
            var w = container.clientWidth || 1;
            var idx = Math.round(container.scrollLeft / w);
            setActive(idx);
          }, { passive: true });
        }
      });
    }
    function initSlideIndicators() {
      bindIndicator('[data-orphee-left-slides]', '.orphee-row__m-left-slide', '.orphee-row__m-left-dot', 'data-left-idx', '__orpheeLeftBound');
      bindIndicator('[data-orphee-right-slides]', '.orphee-row__m-right-slide', '.orphee-row__m-right-dot', 'data-right-idx', '__orpheeRightBound');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSlideIndicators);
    } else {
      initSlideIndicators();
    }
    // Re-init on Shopify section render (theme editor live preview)
    document.addEventListener('shopify:section:load', initSlideIndicators);

    /* ---------- Progressive depth-of-field reveal ----------
       Applies on BOTH desktop and mobile. Rows below the fold start blurred.
       As the user scrolls, a row's blur clears the moment its top crosses
       ~55% (mobile) or ~35% (desktop) of viewport height — desktop fires
       later because rows are visually larger relative to the viewport.
       Once revealed, the row stays sharp (we unobserve it). */
    function initOrpheeProgressiveBlur() {
      if (!('IntersectionObserver' in window)) return;
      var rows = document.querySelectorAll('.orphee-rows--blur-mobile .orphee-row');
      if (rows.length < 2) return;

      var isDesktop = window.matchMedia && window.matchMedia('(min-width: 901px)').matches;
      var rootMargin = isDesktop ? '0px 0px -65% 0px' : '0px 0px -45% 0px';

      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-revealed');
            io.unobserve(en.target);
          }
        });
      }, {
        rootMargin: rootMargin,
        threshold: 0
      });

      // Skip the first row — it's always sharp from initial paint.
      for (var i = 1; i < rows.length; i++) {
        io.observe(rows[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOrpheeProgressiveBlur);
    } else {
      initOrpheeProgressiveBlur();
    }
    document.addEventListener('shopify:section:load', initOrpheeProgressiveBlur);

    /* ---------- Hover videos: ensure autoplay starts even if the browser
       throttles initial play() (e.g. Safari muted autoplay quirk). The video
       runs continuously regardless of hover state — the crossfade just controls
       visibility. ---------- */
    function ensureHoverVideosPlaying() {
      var videos = document.querySelectorAll('.orphee-row__product-img-hover--video');
      videos.forEach(function(video) {
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function(){});
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ensureHoverVideosPlaying);
    } else {
      ensureHoverVideosPlaying();
    }
    document.addEventListener('shopify:section:load', ensureHoverVideosPlaying);
  })();
